import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex relative justify-center w-full mb-8 px-4 sm:px-6 lg:px-8 flex-col mt-20 sm:mt-30" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "absolute inset-0 pointer-events-none z-10 overflow-hidden" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  style: {"display":"none"}
}

import { onMounted, ref } from "vue";
import { Motion, motion } from "motion-v";

interface Props {
  title?: string;
  orientation?: "vertical" | "horizontal";
  links?: Array<{
    label: string;
    to: string;
    variant?: "soft" | "solid" | "outline" | "subtle" | "ghost" | "link";
    trailingIcon?: string;
  }>;
  lightImage?: string;
  darkImage?: string;
  altText?: string;
  titleClass?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroShowcaseCard',
  props: {
    title: { default: "The Family Assessment Solution" },
    orientation: { default: "vertical" },
    links: { default: () => [] },
    lightImage: { default: "/images/app_preview.png" },
    darkImage: { default: "/images/app_preview_dark.png" },
    altText: { default: "FamilyAxis Dashboard" },
    titleClass: { default: "text-purple-800 dark:text-purple-300 md:py-0" }
  },
  setup(__props: any) {



const svgs = [
  "/images/background/tree.svg",
  "/images/background/flower.svg",
  "/images/background/sun.svg",
  "/images/background/heart.svg",
  "/images/background/heart2.svg",
  "/images/background/moon.svg",
  "/images/background/leaf.svg",
  "/images/background/leaf2.svg",
  "/images/background/apple.svg",
  "/images/background/house.svg",
];

const selectedSvgs = ref<Array<{ src: string; style: any }>>([]);

onMounted(() => {
  // Pick 4 random SVGs and assign random positions/animations
  const shuffled = [...svgs].sort(() => 0.5 - Math.random());
  const selected = shuffled.slice(0, 4);

  selectedSvgs.value = selected.map((src, i) => {
    // Random positions around the hero
    const positions = [
      { top: "10%", left: "15%", delay: "0.4s" },
      { top: "0", right: "24%", delay: "0.8s" },
      { bottom: "0", left: "12%", delay: "1.5s" },
      { bottom: "7%", right: "0", delay: "1.9s" },
    ];

    const pos = positions[i];
    const scale = Math.random() * 0.5 + 0.8; // 0.8 to 1.3
    const rotation = Math.floor(Math.random() * 40) - 20; // -20 to 20 deg

    return {
      src,
      style: {
        ...pos,
        transform: `rotate(${rotation}deg) scale(${scale})`,
        animationDelay: pos.delay,
      },
    };
  });
});

return (_ctx: any,_cache: any) => {
  const _component_ClientOnly = _resolveComponent("ClientOnly")!
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_UButton = _resolveComponent("UButton")!
  const _component_UPageHero = _resolveComponent("UPageHero")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ClientOnly, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSvgs.value, (svg, index) => {
              return (_openBlock(), _createElementBlock("img", {
                key: index,
                src: svg.src,
                style: _normalizeStyle(svg.style),
                alt: "",
                class: "absolute w-12 h-12 md:w-20 md:h-20 opacity-0 animate-float-in"
              }, null, 12, _hoisted_4))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_UPageHero, {
        orientation: "vertical",
        headline: "FAMILY ASSESSMENT SOFTWARE",
        ui: {
          container:
            'py-8 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:grid py-6 sm:py-6 lg:py-6 gap-6 sm:gap-y-2',
          title:
            'text-3xl sm:text-5xl md:text-6xl lg:text-6xl text-pretty tracking-tight font-bold text-highlighted mb-6 break-words',
          description:
            'text-base sm:text-lg md:text-xl text-pretty tracking-wide font-extralight text-muted max-w-3xl mx-auto mb-10 px-2',
        }
      }, {
        title: _withCtx(() => [
          _createVNode(_unref(motion).span, {
            initial: { opacity: 0, y: 24 },
            "while-in-view": { opacity: 1, y: 0 },
            viewport: { once: true },
            transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
            class: "block"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" One platform. ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(motion).span, {
            initial: { opacity: 0, y: 24 },
            "while-in-view": { opacity: 1, y: 0 },
            viewport: { once: true },
            transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.12 },
            class: "block sm:inline"
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Built for family-centred ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_unref(motion).span, {
            initial: { opacity: 0, y: 24 },
            "while-in-view": { opacity: 1, y: 0 },
            viewport: { once: true },
            transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.24 },
            class: "relative marker-highlight sm:inline"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" teams. ", -1)
            ]))]),
            _: 1
          })
        ]),
        description: _withCtx(() => [
          _createVNode(_unref(motion).p, {
            initial: { opacity: 0, y: 20 },
            "while-in-view": { opacity: 1, y: 0 },
            viewport: { once: true },
            transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.35 },
            class: "px-2 sm:px-4"
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode(" FamilyAxis brings observations, direct work sessions and tasks into one clear workflow for residential centres, community programs and home visits. Spend less time on paperwork, and more time with families. ", -1)
            ]))]),
            _: 1
          })
        ]),
        links: _withCtx(() => [
          _createVNode(_unref(motion).div, {
            initial: { opacity: 0, y: 20 },
            "while-in-view": { opacity: 1, y: 0 },
            viewport: { once: true },
            transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.5 },
            class: "flex flex-col sm:flex-row justify-center gap-4 px-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NuxtLink, { to: "/signup" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Motion), {
                    "while-hover": { scale: 1.05 },
                    "while-tap": { scale: 0.95 },
                    transition: { type: 'spring', stiffness: 400, damping: 17 },
                    class: "cursor-pointer text-neutral-100 gap-x-2 px-6 py-3 rounded-md font-medium inline-flex items-center justify-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75 bg-primary-600 hover:bg-primary-700 text-base sm:text-lg w-full sm:w-auto"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Get Started ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_UButton, {
                variant: "outline",
                color: "primary",
                size: "xl",
                icon: "i-heroicons-arrow-right",
                label: "Contact Us",
                to: "/contact-sale",
                class: "px-6 py-3 w-full sm:w-auto"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("defs", null, [
          _createElementVNode("filter", { id: "marker-shape" }, [
            _createElementVNode("feTurbulence", {
              type: "fractalNoise",
              baseFrequency: "0.01 0.15",
              numOctaves: "1",
              result: "warp"
            }),
            _createElementVNode("feDisplacementMap", {
              xChannelSelector: "R",
              yChannelSelector: "G",
              scale: "60",
              in: "SourceGraphic",
              in2: "warp"
            })
          ])
        ], -1)
      ]))]))
    ])
  ]))
}
}

})